// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__VtlAS","collapsedRow":"styles_collapsedRow__sKdhC","a":"styles_a__bL8ji"};